import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const OffCanvasNavMenu = ({data}) => {
  const { t } = useTranslation();

  return (
    <nav className="offcanvasNavigation" id="offcanvas-navigation"
    
    >
      <ul>
        {data.map((val, index) => {
          return (
            <li className="menuItemHasChildren" key={index}>
              <Link to={process.env.PUBLIC_URL + val.url}>{t(val.title)}</Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default OffCanvasNavMenu;
